"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var lodash_1 = require("lodash");
var csp_square_card_1 = require("./csp_square_card");
var overflowing_row_1 = require("@reverbdotcom/commons/dist/components/overflowing_row");
var tiles_1 = require("@reverbdotcom/commons/dist/components/tiles");
var condition_filter_1 = require("./condition_filter");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
exports.SIMILAR_CSPS = 'SimilarCSPs';
var CSPSquareRow = /** @class */ (function (_super) {
    tslib_1.__extends(CSPSquareRow, _super);
    function CSPSquareRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CSPSquareRow, "defaultProps", {
        get: function () {
            return {
                pages: [],
                trackName: 'CSPSquareRow',
                trackContext: {},
                expectedCount: 4,
            };
        },
        enumerable: true,
        configurable: true
    });
    CSPSquareRow.prototype.componentDidMount = function () {
        this.trackImpressions();
    };
    CSPSquareRow.prototype.componentDidUpdate = function (prevProps) {
        if (lodash_1.isEqual(this.props.pages, prevProps.pages)) {
            return;
        }
        this.trackImpressions();
    };
    CSPSquareRow.prototype.trackImpressions = function () {
        if (!this.hasPages()) {
            return;
        }
        var event = {
            componentName: this.props.trackName,
            type: tracker_1.CSP_TYPE,
            ids: this.props.pages.map(function (csp) { return csp.id; }),
            context: tslib_1.__assign(tslib_1.__assign({}, this.props.trackContext), { comparison_shopping_pages: this.props.pages.map(function (csp) { return csp.asEvent(); }) }),
        };
        tracker_1.trackView(event);
    };
    CSPSquareRow.prototype.hasPages = function () {
        return this.props.pages.length > 0;
    };
    CSPSquareRow.prototype.renderCards = function () {
        var _this = this;
        return (React.createElement(tiles_1.default, { placeholder: React.createElement(csp_square_card_1.default, null), loading: !this.props.loaded, expectedCount: this.props.expectedCount, fourWideMax: this.props.fourWideMax, singleRow: true, largeTiles: true, grow: true }, this.props.pages.map(function (page, idx) { return (React.createElement(csp_square_card_1.default, { page: page, key: page.id, position: idx, trackName: _this.props.trackName, stripBrandFromTitle: _this.props.stripBrandFromTitle, conditionFilter: condition_filter_1.conditionFilter(_this.props.condition), hideMetadata: _this.props.hideMetadata, renderAsHorizontal: _this.props.pages.length < 4 })); })));
    };
    CSPSquareRow.prototype.render = function () {
        if (this.props.loaded && !this.hasPages()) {
            return null;
        }
        return (React.createElement(overflowing_row_1.default, { title: this.props.title, action: this.props.action, centeredTitle: this.props.centeredTitle, collectionCount: this.props.pages.length }, this.renderCards()));
    };
    return CSPSquareRow;
}(React.Component));
exports.default = CSPSquareRow;
//# sourceMappingURL=csp_square_row.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/csp/csp_square_row.js
// module id = smBk
// module chunks = 20 21